import axiosConfig from "./axiosConfig";

export interface DeleteLeadSearchRequest {
  searchId: string;
  // Whether to drop the search's name as a tag from the leads promoted from it.
  // Required rather than optional: keeping the tag and dropping it are both
  // destructive in different directions, so the caller has to have asked.
  removeTags: boolean;
}

export interface DeleteLeadSearchResponse {
  id: string;
  name: string;
  untaggedLeadCount: number;
}

const deleteLeadSearch = async (
  authToken: string,
  { searchId, removeTags }: DeleteLeadSearchRequest
): Promise<DeleteLeadSearchResponse> => {
  const { data } = await axiosConfig.delete(
    `/leads/searches/${encodeURIComponent(searchId)}?removeTags=${removeTags}`,
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default deleteLeadSearch;
